document.addEventListener('DOMContentLoaded', function () {
  initProductFlickity(document);
});

document.addEventListener('shopify:section:load', function (event) {
  initProductFlickity(event.target);
});

function initProductFlickity(scope) {
  var wrappers = scope.querySelectorAll('[data-product-flickity-instance]');

  wrappers.forEach(function (wrapper) {
    if (wrapper.dataset.flickityInitialised === 'true') return;
    if (typeof Flickity === 'undefined') return;

    var mainCarousel = wrapper.querySelector('[data-product-flickity-main]');
    var navCarousel = wrapper.querySelector('[data-product-flickity-nav]');

    if (!mainCarousel) return;

    var cells = mainCarousel.querySelectorAll('.product-flickity__cell');

    /*
      Image map:
      Image 1 = Black frame
      Image 2 = Oak frame
      Image 3 = White frame
      Image 4 = Unframed / print only artwork
      Image 5 = Canvas
      Image 7 = Lifestyle image, used on page load
    */
    var imageMap = {
      black: 0,
      oak: 1,
      white: 2,
      unframed: 3,
      canvas: 4,
      lifestyle: 6
    };

    var startIndex = cells.length > imageMap.lifestyle ? imageMap.lifestyle : 0;

    var mainFlickity = new Flickity(mainCarousel, {
      cellSelector: '.product-flickity__cell',
      initialIndex: startIndex,
      contain: true,
      draggable: true,
      fade: true,
      adaptiveHeight: true,
      imagesLoaded: true,
      prevNextButtons: true,
      pageDots: false,
      wrapAround: true
    });

    var navFlickity = null;

    if (navCarousel) {
      navFlickity = new Flickity(navCarousel, {
        cellSelector: '.product-flickity-nav__cell',
        initialIndex: startIndex,
        asNavFor: mainCarousel,
        contain: true,
        cellAlign: 'left',
        draggable: true,
        pageDots: false,
        prevNextButtons: false
      });
    }

    function updateVideoPlayback() {
  var selectedCell = mainFlickity.selectedElement;

  mainCarousel.querySelectorAll('video').forEach(function (video) {
    var isSelected =
      selectedCell && selectedCell.contains(video);

    if (isSelected) {
      video.currentTime = 0;

      var playPromise = video.play();

      if (playPromise !== undefined) {
        playPromise.catch(function () {
          // Autoplay may be blocked by the browser.
        });
      }
    } else {
      video.pause();
      video.currentTime = 0;
    }
  });
}

mainFlickity.on('change', updateVideoPlayback);
updateVideoPlayback();

    function clean(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/\s+/g, ' ')
        .trim();
    }

    function getProductSection() {
      return wrapper.closest('.shopify-section') || document;
    }

    function isFrameValue(value) {
      value = clean(value);

      return (
        value.includes('black') ||
        value.includes('oak') ||
        value.includes('white') ||
        value.includes('unframed') ||
        value.includes('print only') ||
        value.includes('wrapped canvas') ||
        value.includes('canvas')
      );
    }

    function getSelectedFrameType() {
      var section = getProductSection();
      var frameValue = '';

      section.querySelectorAll('select').forEach(function (select) {
        var selected = select.options[select.selectedIndex];
        var selectedText = clean(selected ? selected.textContent : '');
        var selectedValue = clean(select.value);
        var combined = clean(selectedValue + ' ' + selectedText);

        var parent = select.closest(
          '.variant-option, fieldset, .product-form__input, variant-picker, variant-selects'
        );

        var parentText = clean(parent ? parent.innerText : '');

        var likelyFrameOption =
          parentText.includes('frame type') ||
          parentText.includes('finish') ||
          parentText.includes('frame') ||
          isFrameValue(combined);

        if (likelyFrameOption && isFrameValue(combined)) {
          frameValue = combined;
        }
      });

      section.querySelectorAll('input[type="radio"]').forEach(function (input) {
        var isSelected =
          input.checked ||
          input.dataset.currentChecked === 'true' ||
          input.getAttribute('aria-checked') === 'true';

        if (!isSelected) return;

        var label = input.closest('label');

        if (!label && input.id) {
          try {
            label = section.querySelector('label[for="' + input.id + '"]');
          } catch (error) {
            label = null;
          }
        }

        var labelText = clean(label ? label.innerText : '');
        var inputValue = clean(input.value || input.getAttribute('aria-label') || '');
        var combined = clean(inputValue + ' ' + labelText);

        var parent = input.closest(
          '.variant-option, fieldset, .product-form__input, variant-picker, variant-radios'
        );

        var parentText = clean(parent ? parent.innerText : '');

        var likelyFrameOption =
          parentText.includes('frame type') ||
          parentText.includes('finish') ||
          parentText.includes('frame') ||
          isFrameValue(combined);

        if (likelyFrameOption && isFrameValue(combined)) {
          frameValue = combined;
        }
      });

      return frameValue;
    }

    function getTargetIndex(frameType) {
      frameType = clean(frameType);

      if (frameType.includes('black')) return imageMap.black;
      if (frameType.includes('oak')) return imageMap.oak;
      if (frameType.includes('white')) return imageMap.white;

      if (
        frameType.includes('wrapped canvas') ||
        frameType.includes('canvas')
      ) {
        return imageMap.canvas;
      }

      if (
        frameType.includes('unframed') ||
        frameType.includes('print only') ||
        frameType === 'print'
      ) {
        return imageMap.unframed;
      }

      return null;
    }

    function safeIndex(index) {
      if (cells[index]) return index;
      if (cells[imageMap.unframed]) return imageMap.unframed;
      return 0;
    }

    function syncImageToVariant(forcedValue) {
      var selectedFrameType = forcedValue || getSelectedFrameType();
      var targetIndex = getTargetIndex(selectedFrameType);

      if (targetIndex === null) return;

      var index = safeIndex(targetIndex);

      mainFlickity.select(index, false, false);

      if (navFlickity) {
        navFlickity.select(index, false, false);
      }
    }

    function scheduleSync(forcedValue) {
      setTimeout(function () {
        syncImageToVariant(forcedValue);
      }, 80);

      setTimeout(function () {
        syncImageToVariant(forcedValue);
      }, 250);

      setTimeout(function () {
        syncImageToVariant(forcedValue);
      }, 500);
    }

    var section = getProductSection();

    section.addEventListener('change', function (event) {
      if (
        event.target.matches('select') ||
        event.target.matches('input[type="radio"]')
      ) {
        scheduleSync(event.target.value || event.target.getAttribute('aria-label') || '');
      }
    });

    section.addEventListener('input', function (event) {
      if (
        event.target.matches('select') ||
        event.target.matches('input[type="radio"]')
      ) {
        scheduleSync(event.target.value || event.target.getAttribute('aria-label') || '');
      }
    });

    section.addEventListener('click', function (event) {
      var variantElement = event.target.closest(
        '.variant-option__button-label, .variant-option, label, select'
      );

      if (!variantElement) return;

      scheduleSync(variantElement.innerText || variantElement.value || '');
    });

    ['variant:change', 'variant:changed', 'product:variant-change'].forEach(function (eventName) {
      document.addEventListener(eventName, function () {
        scheduleSync();
      });
    });

    wrapper.dataset.flickityInitialised = 'true';
  });
}